<template>
  <v-row>
    <v-col md="5" class="pb-0 hidden-sm-and-down">
      <v-img class="sticky-image" height="100vh" src="../../assets/register-dog.png" />
    </v-col>
    <v-col class="register pb-0" md="7" sm="12">
      <h1 class="register-title">Thanks for visiting us!</h1>
      <p>You have been logged out. Click <router-link to="/">here</router-link> to log in again.</p>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import Vue from 'vue';
export default Vue.extend({
  name: 'LoggedOut',
});
</script>
